var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"12px 20px","margin-top":"-8px"},attrs:{"type":_vm.btnType},on:{"click":function($event){_vm.$emit('click')}}},[_c('i',{class:_vm.btnClass})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-b07e77aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/appinfo/bdCardTitle.vue
// module id = null
// module chunks = 